<app-homeone-banner></app-homeone-banner>

<app-homeone-partner></app-homeone-partner>

<app-homeone-blog></app-homeone-blog>
<section class="app-solutions pt-70">
    <app-service-ia></app-service-ia>
</section>

<app-homeone-services></app-homeone-services>

<app-homeone-process></app-homeone-process>

<app-homeone-testimonials></app-homeone-testimonials>

<app-homeone-about></app-homeone-about>
